export const sortByFieldname = (arr, field) => {
  return arr.sort((a, b) => {
    const nameA = String(a[field]).toUpperCase();
    const nameB = String(b[field]).toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  });
};

export const sortPocs = pocs => {
  // sort by first name
  const sortedPocs = sortByFieldname(pocs, 'firstname');

  // then sort by last name
  return sortByFieldname(sortedPocs, 'lastname');
};

/**
 * Switch between ASC and DESC order by strings
 *
 * @param {string} order Order by string to use in query.
 */
export const toggleOrder = (order, lowercase = false) => {
  const toggledOrder = order.toUpperCase() === "DESC" ? "ASC" : "DESC";
  return lowercase ? toggledOrder.toLowerCase() : toggledOrder;
};


// WEBPACK FOOTER //
// ./src/helpers/SortHelper.js